"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.animateToSelector = animateToSelector;
exports.default = void 0;

var _temp, _temp2, _temp3, _temp4, _temp5, _temp6, _temp7, _temp8;

var TimingFunction =
/*#__PURE__*/
function () {
  function TimingFunction() {
    babelHelpers.classCallCheck(this, TimingFunction);
    this._lastValue = 0;
    this.alwaysIncreasing = true;
  }

  babelHelpers.createClass(TimingFunction, [{
    key: "_value",
    value: function _value(percent) {
      return percent;
    }
  }, {
    key: "value",
    value: function value(percent) {
      if (!this.alwaysIncreasing) return this._value(percent);

      var v = this._value(percent);

      if (v < this._lastValue) {
        debugger;
      }

      this._lastPercent = percent;
      this._lastValue = Math.max(this._lastValue, v);
      return this._lastValue;
    }
  }]);
  return TimingFunction;
}();

TimingFunction.functions = {};
TimingFunction.functions.linear = TimingFunction;
TimingFunction.functions.steps = (_temp =
/*#__PURE__*/
function (_TimingFunction) {
  babelHelpers.inherits(_temp, _TimingFunction);

  function _temp(args) {
    var _this;

    babelHelpers.classCallCheck(this, _temp);
    _this = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(_temp).call(this));
    _this.alwaysIncreasing = true;
    var count = args[0];
    var which = args[1];
    _this.count = count;
    _this.which = which;
    _this.bounds = [];

    if (which == 'start') {
      _this.bounds[0] = {
        start: 0,
        end: 0,
        value: 0
      };

      for (var i = 0; i < count; i++) {
        _this.bounds[_this.bounds.length] = {
          start: i / count,
          end: (i + 1) / count,
          value: (i + 1) / count
        };
      }
    } else {
      for (var i = 0; i < count; i++) {
        _this.bounds[_this.bounds.length] = {
          start: i / count,
          end: (i + 1) / count,
          value: i / count
        };
      }

      _this.bounds[_this.bounds.length - 1].end = 0.99999999;
      _this.bounds[_this.bounds.length] = {
        start: 1,
        end: 1,
        value: 1
      };
    }

    return _this;
  }

  babelHelpers.createClass(_temp, [{
    key: "_value",
    value: function _value(percent) {
      percent = Math.min(percent, 1);
      percent = Math.max(percent, 0);
      return this.bounds.filter(function (v) {
        return v.start >= percent && v.end <= percent;
      })[0].value;
    }
  }]);
  return _temp;
}(TimingFunction), _temp); /// Cubic bezier curve impl

/**
 * https://github.com/gre/bezier-easing
 * BezierEasing - use bezier curve for transition easing function
 * by Gaëtan Renaudeau 2014 - 2015 – MIT License
 */

var CubicBezier = function () {
  // These values are established by empiricism with tests (tradeoff: performance VS precision)
  var NEWTON_ITERATIONS = 4;
  var NEWTON_MIN_SLOPE = 0.001;
  var SUBDIVISION_PRECISION = 0.0000001;
  var SUBDIVISION_MAX_ITERATIONS = 10;
  var kSplineTableSize = 11;
  var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
  var float32ArraySupported = typeof Float32Array === 'function';

  function A(aA1, aA2) {
    return 1.0 - 3.0 * aA2 + 3.0 * aA1;
  }

  function B(aA1, aA2) {
    return 3.0 * aA2 - 6.0 * aA1;
  }

  function C(aA1) {
    return 3.0 * aA1;
  } // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.


  function calcBezier(aT, aA1, aA2) {
    return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
  } // Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.


  function getSlope(aT, aA1, aA2) {
    return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
  }

  function binarySubdivide(aX, aA, aB, mX1, mX2) {
    var currentX,
        currentT,
        i = 0;

    do {
      currentT = aA + (aB - aA) / 2.0;
      currentX = calcBezier(currentT, mX1, mX2) - aX;

      if (currentX > 0.0) {
        aB = currentT;
      } else {
        aA = currentT;
      }
    } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);

    return currentT;
  }

  function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
    for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
      var currentSlope = getSlope(aGuessT, mX1, mX2);

      if (currentSlope === 0.0) {
        return aGuessT;
      }

      var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
      aGuessT -= currentX / currentSlope;
    }

    return aGuessT;
  }

  function LinearEasing(x) {
    return x;
  }

  return function bezier(mX1, mY1, mX2, mY2) {
    if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) {
      throw new Error('bezier x values must be in [0, 1] range');
    }

    if (mX1 === mY1 && mX2 === mY2) {
      return LinearEasing;
    } // Precompute samples table


    var sampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);

    for (var i = 0; i < kSplineTableSize; ++i) {
      sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
    }

    function getTForX(aX) {
      var intervalStart = 0.0;
      var currentSample = 1;
      var lastSample = kSplineTableSize - 1;

      for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
        intervalStart += kSampleStepSize;
      }

      --currentSample; // Interpolate to provide an initial guess for t

      var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
      var guessForT = intervalStart + dist * kSampleStepSize;
      var initialSlope = getSlope(guessForT, mX1, mX2);

      if (initialSlope >= NEWTON_MIN_SLOPE) {
        return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
      } else if (initialSlope === 0.0) {
        return guessForT;
      } else {
        return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
      }
    }

    return function BezierEasing(x) {
      // Because JavaScript number are imprecise, we should guarantee the extremes are right.
      if (x === 0) {
        return 0;
      }

      if (x === 1) {
        return 1;
      }

      return calcBezier(getTForX(x), mY1, mY2);
    };
  };
}();

TimingFunction.functions['cubic-bezier'] = (_temp2 =
/*#__PURE__*/
function (_TimingFunction2) {
  babelHelpers.inherits(_temp2, _TimingFunction2);

  function _temp2(args) {
    var _this2;

    babelHelpers.classCallCheck(this, _temp2);
    _this2 = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(_temp2).call(this));
    _this2.alwaysIncreasing = false;
    _this2._impl = CubicBezier(args[0], args[1], args[2], args[3]);
    return _this2;
  }

  babelHelpers.createClass(_temp2, [{
    key: "_value",
    value: function _value(percent) {
      return this._impl(percent);
    }
  }]);
  return _temp2;
}(TimingFunction), _temp2);
TimingFunction.functions.ease = (_temp3 =
/*#__PURE__*/
function (_TimingFunction$funct) {
  babelHelpers.inherits(_temp3, _TimingFunction$funct);

  function _temp3() {
    var _this3;

    babelHelpers.classCallCheck(this, _temp3);
    _this3 = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(_temp3).call(this, [0.25, 0.1, 0.25, 1]));
    _this3.alwaysIncreasing = true;
    return _this3;
  }

  return _temp3;
}(TimingFunction.functions['cubic-bezier']), _temp3);
TimingFunction.functions['ease-in'] = (_temp4 =
/*#__PURE__*/
function (_TimingFunction$funct2) {
  babelHelpers.inherits(_temp4, _TimingFunction$funct2);

  function _temp4() {
    var _this4;

    babelHelpers.classCallCheck(this, _temp4);
    _this4 = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(_temp4).call(this, [0.42, 0, 1, 1]));
    _this4.alwaysIncreasing = true;
    return _this4;
  }

  return _temp4;
}(TimingFunction.functions['cubic-bezier']), _temp4);
TimingFunction.functions['ease-in-out'] = (_temp5 =
/*#__PURE__*/
function (_TimingFunction$funct3) {
  babelHelpers.inherits(_temp5, _TimingFunction$funct3);

  function _temp5() {
    var _this5;

    babelHelpers.classCallCheck(this, _temp5);
    _this5 = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(_temp5).call(this, [0.42, 0, 0.58, 1]));
    _this5.alwaysIncreasing = true;
    return _this5;
  }

  return _temp5;
}(TimingFunction.functions['cubic-bezier']), _temp5);
TimingFunction.functions['ease-out'] = (_temp6 =
/*#__PURE__*/
function (_TimingFunction$funct4) {
  babelHelpers.inherits(_temp6, _TimingFunction$funct4);

  function _temp6() {
    var _this6;

    babelHelpers.classCallCheck(this, _temp6);
    _this6 = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(_temp6).call(this, [0, 0, .58, 1]));
    _this6.alwaysIncreasing = true;
    return _this6;
  }

  return _temp6;
}(TimingFunction.functions['cubic-bezier']), _temp6);
TimingFunction.functions['step-start'] = (_temp7 =
/*#__PURE__*/
function (_TimingFunction$funct5) {
  babelHelpers.inherits(_temp7, _TimingFunction$funct5);

  function _temp7() {
    var _this7;

    babelHelpers.classCallCheck(this, _temp7);
    _this7 = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(_temp7).call(this, [1, 'start']));
    _this7.alwaysIncreasing = true;
    return _this7;
  }

  return _temp7;
}(TimingFunction.functions.steps), _temp7);
TimingFunction.functions['step-end'] = (_temp8 =
/*#__PURE__*/
function (_TimingFunction$funct6) {
  babelHelpers.inherits(_temp8, _TimingFunction$funct6);

  function _temp8() {
    var _this8;

    babelHelpers.classCallCheck(this, _temp8);
    _this8 = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(_temp8).call(this, [1, 'end']));
    _this8.alwaysIncreasing = true;
    return _this8;
  }

  return _temp8;
}(TimingFunction.functions.steps), _temp8);
TimingFunction.instances = {};

TimingFunction.for = function (name) {
  if (TimingFunction.functions[name]) return new TimingFunction.functions[name]();
  if (name.indexOf('(') == -1) return TimingFunction.for('step-start');
  var x = name.substring(0, name.indexOf('('));

  if (TimingFunction.functions[x]) {
    var argList = name.substring(name.indexOf('(') + 1, name.indexOf(')') + 1);
    argList = argList.split(',').map(function (v) {
      return v.replace(/^\s*/, '').replace(/\s*$/, '');
    }).map(function (v) {
      return isNaN(Number(v)) ? v : Number(v);
    });
    return babelHelpers.construct(TimingFunction.functions[x], babelHelpers.toConsumableArray(argList));
  }

  return new TimingFunction.functions['step-start']();
};

var AnimationHelper =
/*#__PURE__*/
function () {
  function AnimationHelper(duration, func, callback, finishCallback) {
    babelHelpers.classCallCheck(this, AnimationHelper);
    this.timingFunc = TimingFunction.for(func);
    this.duration = duration;
    this.callback = callback;

    this.finishCallback = finishCallback || function () {};

    this.ended = false;
  }

  babelHelpers.createClass(AnimationHelper, [{
    key: "start",
    value: function start() {
      this.startTime = Date.now();
      this.run();
    }
  }, {
    key: "stop",
    value: function stop() {
      if (!this.ended) {
        this.ended = true;
        this.finishCallback(false);
      }
    }
  }, {
    key: "run",
    value: function run() {
      var _this9 = this;

      if (this.ended) return;
      var T = Date.now() - this.startTime;
      var P;

      if (!this.duration) {
        P = 1;
      } else {
        P = T / this.duration;
        P = Math.min(1, P);
        P = Math.max(0, P);
      }

      if (isNaN(P)) P = 1;
      this.callback(this.timingFunc.value(P));

      if (P < 1) {
        requestAnimationFrame(function () {
          return _this9.run();
        });
      } else {
        this.ended = true;
        this.finishCallback(true);
      }
    }
  }]);
  return AnimationHelper;
}();

exports.default = AnimationHelper;

function animateToSelector(sel) {
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;
  var func = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'ease';
  var S = $(sel).offset().top;
  var T = document.scrollingElement || document.documentElement;
  var OT = T.scrollTop;
  var D = S - OT;
  var A = new AnimationHelper(duration, func, function (pct) {
    (document.scrollingElement || document.documentElement).scrollTop = OT + D * pct;
  });
  A.start();
}